export default {
  sorry: 'Sorry',
  doNotQualify: 'The minimum conditions are not met, you do not qualify for this product.',
  getInTouch: 'Please contact an advisor.',
  confirmation: {
    title: 'Thank you!',
  },
};
